__turbopack_context__.v({
  "copied": "CopyShareLink-module-scss-module__NgVxpG__copied",
  "copyLinkButton": "CopyShareLink-module-scss-module__NgVxpG__copyLinkButton",
  "copyLinkContainer": "CopyShareLink-module-scss-module__NgVxpG__copyLinkContainer",
  "fadeInOut": "CopyShareLink-module-scss-module__NgVxpG__fadeInOut",
  "icon": "CopyShareLink-module-scss-module__NgVxpG__icon",
  "pulse": "CopyShareLink-module-scss-module__NgVxpG__pulse",
  "tooltip": "CopyShareLink-module-scss-module__NgVxpG__tooltip",
});
